import { httpService } from "./httpService";

/**
 * Tenant-scoped admin-action audit log (most recent 200, newest first).
 * Pass an optional action filter (e.g. "broker.create").
 */
export const getAdminAuditLog = async (action) => {
  const q = action ? `?action=${encodeURIComponent(action)}` : "";
  return httpService({ url: `/audit-log${q}`, options: { method: "GET" } });
};

/**
 * Filtered audit log: action prefix + date range. Use prefix like "plan.cap." to
 * match every cap-block subtype. since/until are epoch ms; either can be null.
 */
export const filterAdminAuditLog = async ({ actionPrefix, since, until, limit } = {}) => {
  const params = new URLSearchParams();
  if (actionPrefix) params.set("actionPrefix", actionPrefix);
  if (since) params.set("since", String(since));
  if (until) params.set("until", String(until));
  if (limit) params.set("limit", String(limit));
  const qs = params.toString() ? `?${params.toString()}` : "";
  return httpService({ url: `/audit-log/filter${qs}`, options: { method: "GET" } });
};
